<template>
  <b-modal
    :title="this.isEdit ? 'Sửa cấp đơn vị' : 'Thêm mới cấp đơn vị'"
    @hidden="hideModal"
    centered
    no-close-on-backdrop
    ref="modalCapNhatCapDonVi"
    size="md"
  >
    <validation-observer ref="observerCapDonVi">
      <b-form>
        <validation-provider
          rules="required|maxlength:50"
          name="Cấp đơn vị"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-4 required"
            id="tenCapDonVi-input-group"
            label="Tên cấp đơn vị"
            label-for="tenCapDonVi-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenCapDonVi-live-feedback"
              class="border-radius-4"
              id="tenCapDonVi-input"
              name="tenCapDonVi-input"
              v-model="form.tenCapDonVi"
            ></b-form-input>
            <b-form-invalid-feedback id="tenCapDonVi-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
      <b-form>
        <validation-provider
          rules="required|maxlength:50|code|hashcode"
          name="Mã cấp đơn vị"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-4 required"
            id="tenCapDonVi-input-group"
            label="Mã cấp đơn vị"
            label-for="tenCapDonVi-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenCapDonVi-live-feedback"
              class="border-radius-4"
              id="tenCapDonVi-input"
              name="tenCapDonVi-input"
              v-model="form.maCapDonVi"
            ></b-form-input>
            <b-form-invalid-feedback id="tenCapDonVi-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
      <b-form-group
        class="mb-4"
        id="thuTu-input-group"
        label="Thứ tự"
        label-class="font-weight-bold"
        label-for="thuTu-input"
      >
        <b-form-input
          aria-describedby="thuTu-live-feedback"
          class="border-radius-4"
          id="thuTu-input"
          name="thuTu-input"
          type="number"
          v-model="form.thuTu"
        ></b-form-input>
      </b-form-group>
    </validation-observer>
    <template v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          button="Lưu"
          @click="onSubmit()"
          class="btn btn-main ml-2"
          :disabled="isLoading"
        >
          {{ isEdit ? "Cập nhật" : "Thêm Mới" }}
        </base-button>
        <base-button
          button="Đóng"
          @click="hideModal()"
          class="btn btn-line"
        >
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
// import { isEmpty } from "lodash";

export default {
  name: "modalCapNhatCapDonVi",
  props: {
    data: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      form: {
        tenCapDonVi: "",
        maCapDonVi: "",
        thuTu: null,
      },
      isLoading: false
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.resetForm();
      this.$refs["modalCapNhatCapDonVi"].hide();
      this.$emit("hidden");
    },
    resetForm() {
      setTimeout(() => {
        this.form = {
          tenCapDonVi: "",
          maCapDonVi: "",
          thuTu: null,
        };
      }, 1000)
    },
    async onSubmit() {
      const isValid = await this.$refs.observerCapDonVi.validate();
      const $vm = this;
      let thuTu = parseInt(this.form.thuTu);
      thuTu = isNaN(thuTu) ? null : thuTu;
      const payload = {
        ...this.form,
        thuTu: thuTu,
      };
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          this.$store
            .dispatch("capDonVi/suaCapDonVi", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        } else {
          this.$store
            .dispatch("capDonVi/themCapDonVi", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              if (err) showMsgError(err.data.message);
              this.isLoading = false;
            });
        }
      }
    },
  },
  watch: {
    isEdit: function () {
      if (this.isEdit) {
        this.form = Object.assign(this.form, this.data);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>
